import { defineMessages } from 'react-intl';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'post-office.rovo-mobile-deep-research-cta-rovo-chat-input.banner-title-mobile-cross-sell',
		defaultMessage: 'Try Rovo on your phone',
		description: 'Title for the Rovo Mobile CTA banner shown in the Rovo chat input',
	},
	description: {
		id: 'post-office.rovo-mobile-deep-research-cta-rovo-chat-input.banner-description-mobile-cross-sell',
		defaultMessage:
			'Ask questions, create Jira work items & Confluence pages - pick up right where you left off.',
		description:
			'Subtitle / supporting text for the Rovo Mobile CTA banner shown in the Rovo chat input',
	},
	dismissButtonLabel: {
		id: 'post-office.rovo-mobile-deep-research-cta-rovo-chat-input.banner-dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Accessibility label for the dismiss button',
	},
});
